<template>
  <div>
    <StaffLoginComponent/>
  </div>
</template>

<script>
import StaffLoginComponent from "@/components/LoginComponents/StaffLoginComponent";

export default {
  components: {StaffLoginComponent},
  title: 'StaffLogin'
}
</script>
